var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEuKlarna(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "980px",
    height: "680px",
    viewBox: "0 0 980 680",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "EU Klarna") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDEDED",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "path-2",
    x: 2.84217094e-14,
    y: 0,
    width: 900,
    height: 600,
    rx: 80
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-6.7%",
    y: "-10.0%",
    width: "113.3%",
    height: "120.0%",
    filterUnits: "objectBoundingBox",
    id: "filter-3"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    radius: 2.5,
    operator: "dilate",
    in: "SourceAlpha",
    result: "shadowSpreadOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0,
    in: "shadowSpreadOuter1",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 17.5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "EU-Klarna",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(40, 40)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-3)",
    xlinkHref: "#path-2"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-1)",
    fillRule: "evenodd",
    xlinkHref: "#path-2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Logo",
    transform: "translate(50.1204, 210.7384)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M702.31783,61.854626 C675.648943,43.6824658 639.623375,48.2035378 618.271849,72.4020774 C596.920324,96.6006171 596.920324,132.908766 618.271849,157.107305 C639.623375,181.305845 675.648943,185.826917 702.31783,167.654757 L702.31783,175.405833 L738.639376,175.405833 L738.639376,54.0952814 L702.31783,54.0952814 L702.31783,61.854626 Z M669.283775,145.967244 C652.261645,145.062037 639.104013,130.684479 639.707703,113.648991 C640.311394,96.6135032 654.453745,83.2033807 671.497251,83.5053657 C688.540756,83.8073507 702.19898,97.7100604 702.19898,114.756242 C701.71511,132.458289 686.986535,146.424284 669.283775,145.967244 L669.283775,145.967244 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 166.206856,
    y: 0.0330712608,
    width: 38.0112804,
    height: 175.374829
  }), /*#__PURE__*/React.createElement("path", {
    d: "M537.757303,50.8315613 C523.260232,49.9747593 509.269832,56.3063814 500.34544,67.7630134 L500.34544,54.1014823 L464.173748,54.1014823 L464.173748,175.4079 L500.780533,175.4079 L500.780533,111.656844 C500.211417,104.246605 502.892937,96.9551585 508.127524,91.6793032 C513.36211,86.4034478 520.632274,83.6647519 528.046754,84.1756601 C544.010872,84.1756601 553.18608,93.7125849 553.18608,111.405709 L553.18608,175.4079 L589.468354,175.4079 L589.468354,98.2629837 C589.468354,70.0304617 567.020202,50.8315613 537.757303,50.8315613 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.133533,61.854626 C292.464646,43.6824658 256.439077,48.2035378 235.087552,72.4020774 C213.736027,96.6006171 213.736027,132.908766 235.087552,157.107305 C256.439077,181.305845 292.464646,185.826917 319.133533,167.654757 L319.133533,175.405833 L355.455079,175.405833 L355.455079,54.0952814 L319.133533,54.0952814 L319.133533,61.854626 Z M286.098444,145.967244 C269.07563,145.064262 255.915898,130.687561 256.518144,113.651456 C257.12039,96.6153517 271.262469,83.203802 288.306552,83.5051243 C305.350636,83.8064467 319.009516,97.709495 319.009516,114.756242 C318.526198,132.457298 303.799195,146.423118 286.09741,145.967244 L286.098444,145.967244 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.643151,69.8971432 L411.643151,54.0963149 L374.455551,54.0963149 L374.455551,175.408934 L411.722728,175.408934 L411.722728,118.7744 C411.722728,99.6643784 432.435672,89.3926515 446.808236,89.3926515 C446.952922,89.3926515 447.093475,89.4071201 447.239196,89.4081536 L447.239196,54.1035492 C433.600593,53.7374644 420.523756,59.5395207 411.643151,69.8971432 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M777.201499,132.380123 C764.610941,132.380694 754.405066,142.58772 754.405066,155.178279 C754.405066,167.768838 764.612319,177.975057 777.202877,177.975057 C789.793436,177.975057 800,167.768149 800,155.17759 C800.000548,149.130979 797.598713,143.331879 793.323017,139.056376 C789.04732,134.780873 783.248111,132.379301 777.201499,132.380123 L777.201499,132.380123 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.006149,3.67164752e-14 L100.61311,3.67164752e-14 C100.736744,32.0384927 85.6150446,62.2258737 59.8817186,81.3118956 L44.2762174,93.0005193 L104.748051,175.463708 L154.464491,175.463708 L98.8251951,99.5858341 C125.330762,73.2423301 140.16486,37.3697749 140.006149,3.67164752e-14 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: -3.67164752e-14,
    y: 0,
    width: 39.4633154,
    height: 175.456474
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEuKlarna);
export default __webpack_public_path__ + "static/media/eu_klarna.1d5c6f4cc5e9450868c8dd31a9f19948.svg";
export { ForwardRef as ReactComponent };